module.exports = __webpack_public_path__ + "static/media/rider.6ec113cc.png";